import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CrmService } from "../../../servicios/crm.service";
import { PdfService } from "../../../servicios/pdf.service";

@Component({
  selector: "app-listado-operaciones-cuotas-gestor-proyectos",
  templateUrl: "./listado-operaciones-cuotas-gestor-proyectos.component.html",
  styleUrls: ["./listado-operaciones-cuotas-gestor-proyectos.component.css"],
})
export class ListadoOperacionesCuotasGestorProyectosComponent implements OnInit {
  operaciones: any[] = [];
  operacionesFiltradas: any[] = [];
  filtrosForm: FormGroup;
  tipoEmpresa: string = "dormaexpansion";
  constructor(
    public dialogRef: MatDialogRef<ListadoOperacionesCuotasGestorProyectosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private crmService: CrmService,
    private snackBar: MatSnackBar,
    private pdfService: PdfService,
  ) {
    // this.operaciones = data.cliente.operacionesCuotasGestorProyectos || [];
    // this.operacionesFiltradas = [...this.operaciones];
    this.filtrosForm = this.fb.group({
      fechaDesde: [""],
      fechaHasta: [""],
      pagoRecibido: [false],
      ordenarPor: ["fechaOrden"],
      orden: ["desc"],
    });

    // // Suscribirse a los cambios de los filtros
    // this.filtrosForm.valueChanges.subscribe(() => {
    //   this.aplicarFiltros();
    // });
  }

  ngOnInit(): void {
    this.operaciones = this.data.cliente.operacionesCuotasGestorProyectos || [];
    this.operacionesFiltradas = [...this.operaciones];

    this.filtrosForm = this.fb.group({
      fechaDesde: [""],
      fechaHasta: [""],
      pagoRecibido: [false],
      ordenarPor: ["fechaOrden"],
      orden: ["desc"],
    });

    // Suscribirse a los cambios de los filtros
    this.filtrosForm.valueChanges.subscribe(() => {
      this.aplicarFiltros();
    });

    this.aplicarFiltros();
  }

  aplicarFiltros(): void {
    let resultado = [...this.operaciones];
    const filtros = this.filtrosForm.value;

    // Filtrar por fecha
    if (filtros.fechaDesde) {
      resultado = resultado.filter(
        (op) => new Date(op.fechaOrden) >= new Date(filtros.fechaDesde),
      );
    }
    if (filtros.fechaHasta) {
      resultado = resultado.filter(
        (op) => new Date(op.fechaOrden) <= new Date(filtros.fechaHasta),
      );
    }

    // Filtrar por estado de pago
    if (filtros.pagoRecibido !== "") {
      resultado = resultado.filter(
        (op) => op.pagoRecibido === filtros.pagoRecibido,
      );
    }

    // Ordenar
    resultado.sort((a, b) => {
      const valorA = a[filtros.ordenarPor];
      const valorB = b[filtros.ordenarPor];

      if (filtros.orden === "asc") {
        return valorA > valorB ? 1 : -1;
      } else {
        return valorA < valorB ? 1 : -1;
      }
    });

    this.operacionesFiltradas = resultado;
  }

  calcularTotal(operacion: any): number {
    const totalEspacio = operacion.cantidadEspacioMB * operacion.precioPorMB;
    const totalTiempo = operacion.cantidadTiempoHoras * operacion.precioPorHora;
    return totalEspacio + totalTiempo;
  }

  cerrar(): void {
    this.dialogRef.close(this.data.cliente);
  }

  async cambiarEstadoPago(operacion: any): Promise<void> {
    if (operacion.pagoRecibido) return;

    const fechaEjecucion = new Date();
    const fechaEjecucionFormateada =
      fechaEjecucion.toLocaleDateString("es-ES") +
      " a las " +
      fechaEjecucion.toLocaleTimeString("es-ES");

    this.crmService
      .popUpConfirmacion({
        textoPrincipal: "¿Estás seguro de querer confirmar la operación?",
        textoSecundario: [
          {
            texto:
              "Se marcará como pagada, se aplicará en el Gestor de Proyectos si aún no lo está y se generará la factura SER automáticamente (creando el cliente en expansión si hace falta). Si el cliente no está activo en facturación, no se cobrará ni se aplicarán las horas.",
          },
        ],
      })
      .afterClosed()
      .subscribe(async (confirmado: boolean) => {
        if (confirmado) {
          try {
            const respuesta: any =
              await this.crmService.marcarOperacionGestorProyectosComoPagada(
                {
                  ...operacion,
                  idDireccion: this.data.idDireccion || null,
                },
                this.data.cliente._id,
              );

            const operacionResultado = respuesta?.resultado?.operacion;
            const fechaEjecucion = new Date();
            operacion.fechaEjecucion =
              operacionResultado?.fechaEjecucion || fechaEjecucion;
            operacion.operacionAplicada = true;
            operacion.pagoRecibido = true;

            if (operacionResultado?.facturaExpansionCreada) {
              operacion.facturaExpansionSerie =
                operacionResultado.facturaExpansionSerie;
              operacion.facturaExpansionNumero =
                operacionResultado.facturaExpansionNumero;
              operacion.facturaExpansionCreada = true;
            }

            if (operacionResultado?.referenciaGdp) {
              operacion.referenciaGdp = operacionResultado.referenciaGdp;
            }

            this.actualizarOperacionEnCliente(operacion);

            if (respuesta?.cliente?.operacionesCuotasGestorProyectos) {
              this.data.cliente.operacionesCuotasGestorProyectos =
                respuesta.cliente.operacionesCuotasGestorProyectos;
              this.operaciones =
                respuesta.cliente.operacionesCuotasGestorProyectos;
              this.aplicarFiltros();
            }

            this.crmService.cuentaGestorProyectos =
              await this.crmService.obtenerCuentaGestorProyectos(
                this.data.cliente._id,
              );

            this.toast(
              respuesta?.mensaje ||
                respuesta?.message ||
                "Estado de pago actualizado correctamente",
            );
          } catch (error: any) {
            console.error("Error al cambiar el estado de pago", error);
            const clienteError: {
              error: {
                cliente: { operacionesCuotasGestorProyectos: any };
                message: string;
                mensaje: string;
              };
              operacionesCuotasGestorProyectos: any;
            } = (error as any)?.error?.cliente;
            if (clienteError?.operacionesCuotasGestorProyectos) {
              this.data.cliente.operacionesCuotasGestorProyectos =
                clienteError.operacionesCuotasGestorProyectos;
              this.operaciones = clienteError.operacionesCuotasGestorProyectos;
              this.aplicarFiltros();
            }
            this.toast(
              error?.error?.message ||
                error?.error?.mensaje ||
                "Error al cambiar el estado de pago",
            );
          }
        }
      });
  }

  async aplicarOperacion(operacion: any): Promise<void> {
    if (operacion.fechaEjecucion) return;

    this.crmService
      .popUpConfirmacion({
        textoPrincipal: "¿Estás seguro de querer aplicar la operación?",
        textoSecundario: [
          {
            texto:
              "Se agregará el tiempo y el espacio a la cuenta del Gestor de Proyectos inmediatamente aunque el cobro no esté recibido aún.",
          },
        ],
      })
      .afterClosed()
      .subscribe(async (confirmado: boolean) => {
        if (confirmado) {
          try {
            await this.crmService.aplicarOperacionGestorProyectos(
              operacion,
              this.data.cliente._id,
            );

            // Actualizar la fecha de la operación en memoria
            const fechaEjecucion = new Date();
            operacion.fechaEjecucion = fechaEjecucion;
            operacion.operacionAplicada = true;

            this.actualizarOperacionEnCliente(operacion);
            this.crmService.cuentaGestorProyectos =
              await this.crmService.obtenerCuentaGestorProyectos(
                this.data.cliente._id,
              );

            this.toast("Estado de aplicación actualizado correctamente");
          } catch (error) {
            console.error("Error al cambiar el estado de aplicación", error);
            this.toast("Error al cambiar el estado de aplicación");
          }
        }
      });
  }

  actualizarOperacionEnCliente(operacion: any): void {
    const index = this.data.cliente.operacionesCuotasGestorProyectos.findIndex(
      (op: any) => op._id === operacion._id,
    );
    this.data.cliente.operacionesCuotasGestorProyectos[index] = operacion;
  }

  async eliminarOperacion(operacion: any): Promise<void> {
    const fecha = new Date(operacion.fechaOrden);
    const fechaFormateada =
      fecha.toLocaleDateString("es-ES") +
      " a las " +
      fecha.toLocaleTimeString("es-ES");

    this.crmService
      .popUpConfirmacion({
        textoPrincipal: "¿Estás seguro de querer eliminar esta operación?",
        textoSecundario: [
          {
            texto:
              "Operación creada el " +
              fechaFormateada +
              " - " +
              "Espacio: " +
              operacion.cantidadEspacioMB +
              " MB - " +
              "Tiempo: " +
              operacion.cantidadTiempoHoras +
              " horas",
          },
        ],
      })
      .afterClosed()
      .subscribe(async (confirmado: boolean) => {
        if (confirmado) {
          try {
            await this.crmService.eliminarOperacionGestorProyectos(
              this.data.cliente._id,
              operacion._id,
            );

            this.operaciones = this.operaciones.filter(
              (op) => op._id !== operacion._id,
            );

            this.aplicarFiltros();

            this.data.cliente.operacionesCuotasGestorProyectos =
              this.operaciones;
            this.toast("Operación eliminada correctamente");
          } catch (error) {
            console.error("Error al eliminar la operación", error);
            this.toast("Error al eliminar la operación");
          }
        }
      });
  }

  async generarPedidoGDP(operacion: any, tipoEmpresa: string): Promise<void> {
    try {
      const pdfUrl = await this.pdfService.generarPedidoGDP(
        this.data.cliente,
        operacion,
        tipoEmpresa,
      );
      window.open(this.crmService.urlCRM + pdfUrl, "_blank");
    } catch (error) {
      console.error("Error al generar el PDF del pedido", error);
    }
  }

  cambiarRecargoEquivalencia(operacion: any, valor: boolean): void {
    operacion.recargoEquivalencia = valor;
    this.actualizarOperacionEnCliente(operacion);
  }

  private toast(msg: string = "Desconocido"): void {
    this.snackBar.open(msg, "OK", { duration: 7000 });
  }

  generarNumeroPedidoGDP(fechaOrden: Date): string {
    const fecha = new Date(fechaOrden);
    const dia = fecha.getDate().toString().padStart(2, "0");
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const anio = fecha.getFullYear().toString().slice(-2).padStart(2, "0");
    const hora = fecha.getHours().toString().padStart(2, "0");
    const minutos = fecha.getMinutes().toString().padStart(2, "0");
    const segundos = fecha.getSeconds().toString().padStart(2, "0");
    return `GDP${anio}${mes}${dia}${hora}${minutos}${segundos}`;
  }
}
